import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["MarketplaceIntelligencePublicReport"] */ "/app/src/components/marketplace-intelligence/MarketplaceIntelligencePublicReport.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/app/src/components/Navbar.tsx");
